import translations from "../translation.json";

export function useGetEventColumns(language) {
  const allfields = [
    {
      content: translations.commonFields.firstName[language],
      name: "first_name",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.lastName[language],
      name: "last_name",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.phone[language],
      name: "phone",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.officeNumber[language],
      name: "office_phone",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.mobileNumber[language],
      name: "mobile_phone",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.email[language],
      name: "email",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.make[language],
      name: "make",
      type: "text",
      filterType: "",
      value: "",
    },

    {
      content: translations.createProspective.model[language],
      name: "model",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.usersPage.createUser.year[language],
      name: "year",
      type: "number",
      filterType: "",
      value: "",
    },
    {
      content: "KM",
      name: "km",
      type: "text",
      filterType: "",
      value: "",
    },

    {
      content: translations.clients.table.callStatus[language],
      name: "call_status",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.address[language],
      name: "address",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.city[language],
      name: "city",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.province[language],
      name: "province",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: "Activix ID",
      name: "activix_id",
      type: "number",
      filterType: "",
      value: "",
    },
    {
      content: translations.clients.table.prospectiveType[language],
      name: "prospective_type",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content:
        translations.forms.formFields.conquestSection.postalCode[language],
      name: "postal_code",
      type: "text",
      filterType: "",
      value: "",
    },

    {
      content: translations.appointments.appointment[language],
      name: "appointment",
      type: "dropdown",
      filterType: "",
      value: "",
    },

    {
      content: translations.commonFields.language[language],
      name: "language",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.VIN[language],
      name: "vin",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.purchaseDate[language],
      name: "purchase_date",
      type: "date",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.lastServiceDate[language],
      name: "last_service_date",
      type: "date",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.prospectiveSource[language],
      name: "prospect_source",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.greetings[language],
      name: "greetings",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: "OG Rep",
      name: "og_rep",
      type: "text",
      filterType: "",
      value: "",
    },
  ];
  const textOptions = [
    {
      label: translations.commonFields.queryFilters.contain[language],
      value: "like",
    },
    {
      label: translations.commonFields.queryFilters.notContain[language],
      value: "not like",
    },
    {
      label: translations.commonFields.queryFilters.equal[language],
      value: "=",
    },
    {
      label: translations.commonFields.queryFilters.notEqual[language],
      value: "!=",
    },
  ];
  const textOptions2 = [
    {
      label: translations.commonFields.queryFilters.equal[language],
      value: "=",
    },
    {
      label: translations.commonFields.queryFilters.notEqual[language],
      value: "!=",
    },
  ];
  const appointmentOption = [
    { label: translations.dropdown.yes[language], value: "1" },
    { label: translations.dropdown.no[language], value: "0" },
  ];
  const prospectiveSourceOptions2 = [
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt1[language],
      value: translations.createProspective.prospectiveSourceOptions.opt1["en"],
    },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt2[language],
      value: translations.createProspective.prospectiveSourceOptions.opt2["en"],
    },
    // {
    //   label:
    //     translations.createProspective.prospectiveSourceOptions.opt3[language],
    //   value: translations.createProspective.prospectiveSourceOptions.opt3["en"],
    // },
    // {
    //   label:
    //     translations.createProspective.prospectiveSourceOptions.opt4[language],
    //   value: translations.createProspective.prospectiveSourceOptions.opt4["en"],
    // },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt5[language],
      value: translations.createProspective.prospectiveSourceOptions.opt5["en"],
    },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt6[language],
      value: translations.createProspective.prospectiveSourceOptions.opt6["en"],
    },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt7[language],
      value: translations.createProspective.prospectiveSourceOptions.opt7["en"],
    },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt8[language],
      value: translations.createProspective.prospectiveSourceOptions.opt8["en"],
    },
  ];
  const prospectiveSourceOptions = Object.keys(
    translations.createProspective.prospectiveSourceOptions,
  ).map((key) => ({
    label: {
      en: translations.createProspective.prospectiveSourceOptions[key]["en"],
      fr: translations.createProspective.prospectiveSourceOptions[key]["fr"],
    },
    value: {
      en: translations.createProspective.prospectiveSourceOptions[key]["en"],
      fr: translations.createProspective.prospectiveSourceOptions[key]["fr"],
    },
  }));
  const confirmationStatusOptions = [
    {
      label:
        translations.createProspective.confirmationSatusOptions.opt1[language],
      value: "CONFIRMED",
    },
    {
      label:
        translations.createProspective.confirmationSatusOptions.opt2[language],
      value: "Wants callback",
    },
    {
      label:
        translations.createProspective.confirmationSatusOptions.opt3[language],
      value: "Message left",
    },
    {
      label:
        translations.createProspective.confirmationSatusOptions.opt4[language],
      value: "NO ANSWER",
    },
    {
      label:
        translations.createProspective.confirmationSatusOptions.opt5[language],
      value: "SAVED",
    },
    {
      label:
        translations.createProspective.confirmationSatusOptions.opt6[language],
      value: "CANCEL",
    },
  ];
  const visitStatusOptions = [
    {
      label: translations.createProspective.visitStatusOptions.opt1[language],
      value: translations.createProspective.visitStatusOptions.opt1["en"],
    },
    {
      label: translations.createProspective.visitStatusOptions.opt2[language],
      value: translations.createProspective.visitStatusOptions.opt2["en"],
    },
    {
      label: translations.createProspective.visitStatusOptions.opt3[language],
      value: translations.createProspective.visitStatusOptions.opt3["en"],
    },
    {
      label: translations.createProspective.visitStatusOptions.opt4[language],
      value: translations.createProspective.visitStatusOptions.opt4["en"],
    },
    {
      label: translations.createProspective.visitStatusOptions.opt5[language],
      value: translations.createProspective.visitStatusOptions.opt5["en"],
    },
    {
      label: translations.createProspective.visitStatusOptions.opt6[language],
      value: translations.createProspective.visitStatusOptions.opt6["en"],
    },
  ];
  const noShowOptions = [
    {
      label: translations.createProspective.noShowStatusOptions.opt1[language],
      value: translations.createProspective.noShowStatusOptions.opt1["en"],
    },
    {
      label: translations.createProspective.noShowStatusOptions.opt2[language],
      value: translations.createProspective.noShowStatusOptions.opt2["en"],
    },
    {
      label: translations.createProspective.noShowStatusOptions.opt3[language],
      value: translations.createProspective.noShowStatusOptions.opt3["en"],
    },
    {
      label: translations.createProspective.noShowStatusOptions.opt4[language],
      value: translations.createProspective.noShowStatusOptions.opt4["en"],
    },
    {
      label: translations.createProspective.noShowStatusOptions.opt5[language],
      value: translations.createProspective.noShowStatusOptions.opt5["en"],
    },
    {
      label: translations.createProspective.noShowStatusOptions.opt6[language],
      value: translations.createProspective.noShowStatusOptions.opt6["en"],
    },
  ];
  const defaultViewColumns = {
    name: "Default View",
    current: true,
    type: "default client",
    csv: true,
    xlsx: true,
    columns: [
      {
        id: "id",
        content: "ID",
        style: {},
        className: "text-center",
        width: 40,
        renderInView: true,
      },
      {
        id: "prospect_type",
        content: translations.clients.table.prospectiveType[language],
        minWidth: language === "en" ? "145px" : "150px",
        width: language === "en" ? 145 : 170,
        renderInView: true,
      },
      {
        id: "prospect_source",
        content: translations.createProspective.prospectiveSource[language],
        minWidth: language === "en" ? "140px" : "165px",
        width: language === "en" ? 160 : 185,
        renderInView: true,
      },
      {
        id: "first_name",
        content: translations.commonFields.firstName[language],
        style: { minWidth: "100px" },
        width: 120,
        renderInView: true,
      },
      {
        id: "last_name",
        content: translations.commonFields.lastName[language],
        width: language === "en" ? 120 : 165,
        style: {
          minWidth: language === "en" ? "100px" : "135px",
        },
        renderInView: true,
      },
      {
        id: "phone",
        content: translations.quickCreationModal.phoneNumber[language],
        width: language === "en" ? 150 : 200,
        style: {
          minWidth: language === "en" ? "130px" : "180px",
        },
        renderInView: true,
      },
      {
        id: "office_phone",
        content: translations.createProspective.officeNumber[language],
        style: { minWidth: language === "en" ? "130px" : "155px" },
        width: language === "en" ? 150 : 185,
        renderInView: true,
      },
      {
        id: "email",
        content: translations.commonFields.email[language],
        width: 100,
        style: {
          minWidth: 100,
        },
        renderInView: true,
      },
      {
        id: "og_rep",
        content: translations.commonWords.usersTypes.representative[language],
        style: {
          whiteSpace: "normal",
        },
        width: 150,
        renderInView: true,
      },
      {
        id: "call_status",
        content: translations.clients.table.callStatus[language],
        width: 150,
        renderInView: true,
      },
      {
        id: "make",
        content: translations.createProspective.make[language],
        width: 100,
        renderInView: true,
      },
      {
        id: "model",
        content: translations.createProspective.model[language],
        width: 100,
        renderInView: true,
      },
      {
        id: "year",
        content: translations.usersPage.createUser.year[language],
        width: language === "en" ? 95 : 90,
        style: {
          minWidth: language === "en" ? "95px" : "90px",
        },
        renderInView: true,
      },
      {
        id: "general_comment",
        content: translations.createProspective.generalComment[language],
        width: language === "en" ? 95 : 90,
        style: {
          minWidth: language === "en" ? "180px" : "230px",
        },
        renderInView: true,
      },
      {
        id: "km",
        content: "KM",
        width: 100,
        style: {
          minWidth: 100,
        },
        renderInView: true,
      },
      {
        id: "address",
        content: translations.commonFields.address[language],
        width: 100,
        style: {
          minWidth: 100,
        },
        renderInView: true,
      },
      {
        id: "city",
        content: translations.commonFields.city[language],
        width: 100,
        style: {
          minWidth: 100,
        },
        renderInView: true,
      },
      {
        id: "province",
        content: translations.commonFields.province[language],
        width: 100,
        style: {
          minWidth: 100,
        },
        renderInView: true,
      },
      {
        id: "postal_code",
        content:
          translations.forms.formFields.conquestSection.postalCode[language],
        width: 150,
        style: {
          minWidth: 150,
        },
        renderInView: true,
      },
      {
        id: "appointment",
        content: translations.appointments.appointment[language],
        width: language === "fr" ? 150 : 100,
        style: {
          minWidth: language === "fr" ? 150 : 100,
        },
        renderInView: true,
      },
      {
        id: "mobile_phone",
        content: translations.commonFields.mobileNumber[language],
        width: 150,
        style: {
          minWidth: 150,
        },
        renderInView: true,
      },
      {
        id: "language",
        content: translations.commonFields.language[language],
        width: 100,
        style: {
          minWidth: 100,
        },
        renderInView: true,
      },
      {
        id: "vin",
        content: translations.createProspective.VIN[language],
        width: 100,
        style: {
          minWidth: 100,
        },
        renderInView: true,
      },
      {
        id: "purchase_date",
        content: translations.createProspective.purchaseDate[language],
        width: 150,
        style: {
          minWidth: 150,
        },
        renderInView: true,
      },
      {
        id: "last_service_date",
        content: translations.createProspective.lastServiceDate[language],
        width: language === "fr" ? 180 : 150,
        style: {
          minWidth: language === "fr" ? 180 : 150,
        },
        renderInView: true,
      },

      {
        id: "greetings",
        content: translations.createProspective.greetings[language],
        width: 100,
        style: {
          minWidth: 100,
        },
        renderInView: true,
      },
      {
        id: "confirmation_status",
        content: translations.createProspective.confirmationStatus[language],
        style: {
          minWidth: language === "en" ? "170px" : "195px",
        },
        width: language === "en" ? 190 : 225,
        renderInView: true,
      },
      {
        id: "confirmation_notes",
        content: translations.createProspective.confirmationNotes[language],
        style: {
          minWidth: language === "en" ? "165px" : "195px",
        },
        width: language === "en" ? 195 : 225,
        renderInView: true,
      },
      {
        id: "visit_status",
        content: translations.createProspective.visitStatus[language],
        width: language === "en" ? 150 : 255,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "visit_notes",
        content: translations.createProspective.visitNotes[language],
        width: language === "en" ? 150 : 255,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "no_show_status",
        content: translations.clients.table.noShowStatus[language],
        width: language === "en" ? 170 : 225,
        style: {
          minWidth: language === "en" ? "170px" : "195px",
        },
        renderInView: true,
      },
      {
        id: "no_show_notes",
        content: translations.createProspective.noShowNotes[language],
        width: language === "en" ? 150 : 255,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "appointment_rep_user_name",
        content:
          translations.createProspective.appointmentRepresentative[language],
        width: language === "en" ? 260 : 255,
        style: {
          minWidth: language === "en" ? "280px" : "295px",
        },
        renderInView: true,
      },
      {
        id: "appointment_time",
        content: translations.clients.table.appointmentTime[language],
        width: language === "en" ? 190 : 255,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "appointment_date",
        content: translations.clients.table.appointmentDate[language],
        width: language === "en" ? 220 : 255,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "appointment_comment",
        content: translations.createProspective.appointmentComment[language],
        width: language === "en" ? 220 : 255,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "import_note",
        content: translations.createProspective.import_note[language],
        width: language === "en" ? 220 : 255,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "group_code",
        content: translations.createProspective.group_code[language],
        width: language === "en" ? 220 : 255,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "create_by",
        content: translations.createProspective.bookedBy[language],
        width: language === "en" ? 120 : 180,
        style: {
          minWidth: language === "en" ? "220px" : "255px",
        },
        renderInView: true,
      },
      {
        id: "actions",
        content:
          translations.EventsPortal.eventsTableHeader.actions[language],
        style: {
          position: "-webkit-sticky",
          position: "sticky",
          right: 0,
        },
        width: 100,
        className: "text-center",
        colSpan: 3,
        renderInView: true,
      },
    ],
  };

  return {
    noShowOptions,
    visitStatusOptions,
    confirmationStatusOptions,
    prospectiveSourceOptions,
    prospectiveSourceOptions2,
    appointmentOption,
    textOptions2,
    textOptions,
    allfields,
    defaultViewColumns
  };
}
